<template>
	<div>
		<table-widget v-if="isPopularArticle"></table-widget>
		<div class="today_bubble" v-if="isInternalPopularArticle"/>
		<card-widget v-if="widgetType === 'card'" :articles="articles" :config="config" ref="cardWidget"></card-widget>
		<text-widget v-else-if="widgetType === 'text'" :articles="articles" :config="config"></text-widget>
	</div>
</template>

<script>
import axios from 'axios';
import TableWidget from './components/TableWidget.vue';
import CardWidget from './components/CardWidget.vue';
import TextWidget from './components/TextWidget.vue';

const POPULAR_SVC_CODE = {
	TOP: 'topRank',
	DAUM: 'daumapp',
	KAKAOTALK: 'kakaotalkTab'
}

export default {
	components: {
		TableWidget, CardWidget, TextWidget
	},
	props: {
		requestConfig: Object,
		articleWidgetConfig: Object
	},
	data() {
		return {
			articles: []
		};
	},
	computed: {
		svc() {
			return this.articleWidgetConfig.svcParam;
		},
		isPopularArticle() {
			return this.isInternalPopularArticle || this.isExternalPopularArticle;
		},
		isInternalPopularArticle() {
			return this.svc === POPULAR_SVC_CODE.TOP;
		},
		isExternalPopularArticle() {
			return this.svc === POPULAR_SVC_CODE.DAUM || this.svc === POPULAR_SVC_CODE.KAKAOTALK;
		},
		widgetType() {
			if (this.isExternalPopularArticle) {
				return 'card';
			}
			return 'text';
		},
		config() {
			return {
				...this.articleWidgetConfig,
				isValidCode: this.isPopularArticle,
				isExternalPopularArticle: this.isExternalPopularArticle
			}
		}
	},
	async created() {
		const {data} = await axios.get(this.requestConfig.url, {
			params: this.requestConfig.data,
			timeout: 5000,
			cache: false
		});
		this.articles = data;

		if (this.articleWidgetConfig.isDaumSearch && (!data || data.length === 0)) {
			document.getElementById('linkAlarmDiv').style.display = 'block';
		}

		await this.$nextTick();

		this.$refs.cardWidget.fetchAdfitNativeAds();
	},
	mounted() {
		if (!this.isInternalPopularArticle) {
			return;
		}

		cafe.todayBubble.init('.today_bubble');
	}
}
</script>
